import { render, staticRenderFns } from "./FormatPageEditor.vue?vue&type=template&id=92d9ce8e&scoped=true&"
import script from "./FormatPageEditor.vue?vue&type=script&lang=ts&"
export * from "./FormatPageEditor.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPageEditor.vue?vue&type=style&index=0&id=92d9ce8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92d9ce8e",
  null
  
)

export default component.exports